<template>
    <v-card class="card-container">
        <v-card-title>
            <v-row no-gutters class="header">
                <v-col xs="12" sm="12" md="5" lg="4" xl="3">
                    <span class="subheader-label">Зарегистрирован:</span>
                    <span class="subheader-strong-label">{{this.formatDate(item.registerDateTime)}}</span> •
                    <span :class="{'status-label':true,'client-st1':item.clientStatusCode=='CS01','client-st2':item.clientStatusCode=='CS02','client-st4':item.clientStatusCode=='CS04'}">{{editClientModel.clientStatusName}}</span>
                    <span class="subheader-strong-label" v-if="item.clientStatusCode=='CS02'"> ({{this.formatDate(item.activationDateTime)}})</span>
                </v-col >
                <v-col xs="12" sm="12" md="5" lg="4" xl="3">
                    <span class="subheader-label">Продавец:</span> <span class="subheader-strong-label">{{item.webUser}}</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn
                            outlined
                            color="var(--color-red)"
                            size="sm"
                            @click="deleteItem"
                    >
                        <v-icon>mdi-delete</v-icon> Удалить клиента
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <b-container fluid class="h-100">
                <v-row no-gutters class="h-100">
                    <v-col class="py-5" xs="12" sm="12" md="6" lg="6" xl="6">
                        <b-row class="mb-1">
                            <b-col>
                                <label class="custom-input-label">ФИО <span v-if="canEdit" class="mark-required">*</span></label>
                                <b-input
                                        v-if="canEdit"
                                        placeholder="Иванов Иван Иванович"
                                        v-model="editClientModel.fullName"
                                        :state="errors.findIndex(x=>x.key='fullName')!=-1?editClientModel.fullName!=null?true:false:null"
                                />

                                <div v-else class="disabled-filled-option">{{editClientModel.fullName}}</div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-5">
                            <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                <label class="custom-input-label">Дата рождения <span v-if="canEdit" class="mark-required">*</span></label>
                                <b-input
                                        v-if="canEdit"
                                        type="date"
                                        placeholder="дд.ММ.гггг"
                                        v-model="editClientModel.dateBirth"
                                        :state="errors.findIndex(x=>x.key='dateBirth')!=-1?editClientModel.dateBirth!=null?true:false:null"

                                />
                                <div v-else class="disabled-filled-option">{{editClientModel.dateBirth}}</div>
                            </b-col>
                        </b-row>
                        <template v-if="canEdit">
                            <b-row no-gutters class="mb-1">
                                <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                    <label class="custom-input-label">Марка транспортного средства <span class="mark-required">*</span></label>
                                    <b-select
                                            v-model="editClientModel.carMarkId"
                                            :state="errors.findIndex(x=>x.key='carMarkId')!=-1?editClientModel.carMarkId!=null?true:false:null"
                                            :options="Marks"
                                            @input="markSelect"
                                    />
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="mb-1">
                                <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                    <label class="custom-input-label">Модель <span class="mark-required">*</span></label>
                                    <b-select
                                            :disabled="editClientModel.carMarkId==null"
                                            v-model="editClientModel.carModelId"
                                            :state="errors.findIndex(x=>x.key='carModelId')!=-1?editClientModel.carModelId!=null?true:false:null"
                                            :options="Models"
                                    />
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="mb-1">
                                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                    <label class="custom-input-label">Год выпуска <span class="mark-required">*</span></label>
                                    <b-input
                                            v-model="editClientModel.carYear"
                                            type="number"
                                            :state="errors.findIndex(x=>x.key='carYear')!=-1?editClientModel.carYear!=null?true:false:null"
                                    />
                                </b-col>
                            </b-row>
                        </template>
                        <b-row v-else class="mb-1">
                            <b-col>
                                <label class="custom-input-label">Транспортное средство </label>
                                <div class="disabled-filled-option">{{editClientModel.carMark+' '+editClientModel.carModel+' '+editClientModel.carYear}}</div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                <label class="custom-input-label">Гос. номер ТС</label>
                                <b-input
                                        v-if="canEdit"
                                        v-model="editClientModel.carNumber"
                                        placeholder="A000AA00"
                                />
                                <div v-else class="disabled-filled-option">{{editClientModel.carNumber}}</div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                <label class="custom-input-label">Полис ОСАГО</label>
                                <div class="disabled-filled-option">{{editClientModel.osago}}</div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-5">
                            <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                <label class="custom-input-label">Полис КАСКО</label>
                                <div class="disabled-filled-option">{{editClientModel.kasko}}</div>
                            </b-col>
                        </b-row>

                        <b-row class="mb-1">
                            <b-col>
                                <label class="custom-input-label">Зарегистрировавшая организация</label>
                                <div class="disabled-filled-option">{{editClientModel.organization}}</div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                <label class="custom-input-label">Адрес филиала регистрации</label>
                                <div class="disabled-filled-option">{{editClientModel.orgGeoInfo}}</div>
                            </b-col>
                        </b-row>

                        <b-row class="mb-5">
                            <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                                <label class="custom-input-label">Тип бонусного пакета <span v-if="canEdit" class="mark-required">*</span></label>
                                <b-select
                                        v-if="canEdit"
                                        :options="packages"
                                        text-field="name"
                                        value-field="id"
                                        :state="errors.findIndex(x=>x.key='bonusPacketId')!=-1?editClientModel.bonusPacketId!=null?true:false:null"
                                        v-model="editClientModel.bonusPacketId"
                                />
                                <div v-else class="disabled-filled-option">{{editClientModel.bonusPacketName}}</div>
                            </b-col>
                        </b-row>

                        <b-row class="mb-1">
                            <b-col>
                                <label class="custom-input-label">Email</label>
                                <div class="disabled-filled-option">{{editClientModel.eMail}}</div>
                            </b-col>
                        </b-row>

                        <b-row class="mb-1">
                            <b-col>
                                <label class="custom-input-label">Телефон</label>
                                <div class="disabled-filled-option phone">+7{{editClientModel.account}}</div>
                                <label class="phone" data-fon="+7">&nbsp;</label>
                            </b-col>
                        </b-row>
                        <v-row no-gutters  justify="space-between">

                            <v-col cols="auto" class="mr-2">
                                <v-btn
                                        color="var(--color-blue)"
                                        dark
                                        size="sm"
                                        @click="onSave"
                                >
                                    Сохранить
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-col>
                </v-row>

            </b-container>
        </v-card-text>
    </v-card>

</template>

<script>
    import axios from 'axios'
    import { mapGetters } from 'vuex';
    import mapper from 'automapper'

    export default {
        name: "ClientInfoData",
        props:{
            item:Object,

        },
        data(){
            return{
                loading: false,
                errors: [],
                identityModel: {
                    login: null,
                    email: null,
                    phoneNumber: null,
                    userName: null,
                    isClient: true,
                    isAdministrator: false,
                    organizationId: null,
                    webSite: '',
                },
                editClientModel: {
                    id: null,
                    account: null,
                    fullName: null,
                    eMail: null,
                    identityId: null,
                    isActive: true,
                    organizationId: null,
                    organization: null,
                    orgGeoInfo:null,
                    bonusPacketName:null,
                    bonusPacketId:null,
                    carModelId: null,
                    carModel: null,
                    carMarkId: null,
                    carMark: null,
                    carYear: 0,
                    carNumber: null,
                    dateBirth: null,
                    osago: null,
                    kasko: null,
                    clientStatusName:null,
                },
            }
        },
        created(){
            this.$store.dispatch("Cars/loadMarks").catch((err) => {
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки марок авто!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });

            //получить список бонусных пакетов
            this.$store.dispatch("Bonuses/loadBonusPackages").catch(err=>{
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка пользователей!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });

            mapper.createMap("editMobileUserModel", "identityModel")
                .forMember('login', function () {
                    this.mapFrom('account')
                })
                .forMember('userName', function () {
                    this.mapFrom('fullName')
                })
                .forMember('isAdministrator', function () {
                    this.ignore()
                })
                .forMember('isClient', function () {
                    this.ignore()
                })
                .forMember('webSite', function () {
                    return null
                })
                .forMember('phoneNumber', function () {
                    this.mapFrom('account')
                })
                .forMember('email', function () {
                    this.mapFrom('eMail')
                })

        },
        mounted(){
            this.resetModel()
        },
        computed:{
            ...mapGetters({
                carModels:"Cars/getModels",
                webUserInfo:"userData/getWebUser"
            }),

            canEdit(){
                return this.item.clientStatusCode=='CS01'
            },

            //список марок
            Marks() {
                var res = [];
                var items = this.$store.state.Cars.carMarks;
                if (items != null) {
                    items.forEach(item => {
                        res.push({text: item.carMarkName, value: item.id})
                    })
                }
                return res.sort((a,b)=>{
                    var nameA=a.text.toLowerCase(), nameB=b.text.toLowerCase()
                    if (nameA < nameB)
                        return -1
                    if (nameA > nameB)
                        return 1
                    return 0
                });
            },

            //получить список моделей выбранной марки
            Models(){
                if(this.editClientModel.carMarkId!=null){
                    var items =this.carModels(this.editClientModel.carMarkId);
                    if(items!=null) {
                        var res=[];
                        items.sort((a,b)=>{
                            var nameA=a.carModelName.toLowerCase(), nameB=b.carModelName.toLowerCase()
                            if (nameA < nameB)
                                return -1
                            if (nameA > nameB)
                                return 1
                            return 0
                        }).forEach(item => {
                            res.push({text: item.carModelName, value: item.id})
                        });
                        return res;
                    }
                    else return [];
                }
                else  return [];
            },

            packages(){
                return this.$store.state.Bonuses.bonusPackages
            },
        },
        methods:{

            resetModel(){
                for( let key in this.editClientModel){
                    if(this.item.hasOwnProperty(key)) {
                        if (key == 'dateBirth') {
                            this.editClientModel[key] =this.item[key].split("T")[0]
                        }
                        else
                            this.editClientModel[key] = this.item[key]
                    }
                }
            },

            //форматирование номера телефона
            formatPhone(value, e){
                //оставляем только цифры
                value= value.replace(/\D/,"")
                value=value.replace(/^[0-8]/,"")
                return value.substr(0,10);
            },

            markSelect(e) {
                //если нет записи о моделях, то подтягиваем с апи
                if (this.editClientModel.carMarkId != null) {
                    var models = this.carModels(this.editClientModel.carMarkId)
                    if (models == null)
                        try {
                            this.$store.dispatch("Cars/loadModels", this.editClientModel.carMarkId).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка загрузки моделей авто!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                        } catch (e) {
                            console.log(e);
                        }
                }
            },

            validateModel() {
                var noError = true;
                this.errors = [];

                if (this.editClientModel.fullName == null || this.editClientModel.fullName == '') {
                    this.errors.push({key: "userName", mes: "Необходимо указать ФИО!"});
                    noError = false;
                }

                if (this.editClientModel.account == null || this.editClientModel.account == '') {
                    this.errors.push({key: "account", mes: "Необходимо указать Номер телефона!"});
                    noError = false;
                }

                if (this.editClientModel.bonusPacketId == null || this.editClientModel.bonusPacketId == '') {
                    this.errors.push({key: "bonusPacketId", mes: "Необходимо указать бонусный пакет!"});
                    noError = false;
                }

                if (this.editClientModel.carMarkId == null || this.editClientModel.carMarkId == '') {
                    this.errors.push({key: "carMarkId", mes: "Необходимо выбрать модель авто!"});
                    noError = false;
                }

                if (this.editClientModel.carModelId == null || this.editClientModel.carModelId == '') {
                    this.errors.push({key: "carModelId", mes: "Необходимо выбрать марку авто!"});
                    noError = false;
                }

                if (this.editClientModel.dateBirth == null || this.editClientModel.dateBirth == '') {
                    this.errors.push({key: "dateBirth", mes: "Необходимо указать дату рождения!"});
                    noError = false;
                }
                if (this.editClientModel.carYear == null || this.editClientModel.carYear == '') {
                    this.errors.push({key: "carYear", mes: "Необходимо указать дату рождениягод выпуска ТС!"});
                    noError = false;
                }

                return noError;

            },


            async onSave() {
                const vm = this;
                //проверяем на заполнение полей
                if (this.validateModel() == true) {
                    var curUser = this.$store.state.userData.curUser;

                        //приводим модель к идентити
                        mapper.map("editMobileUserModel", "identityModel", this.editClientModel, this.identityModel);

                        var isOk = false;
                        await axios.post(`${vm.$root.identityURL}/api/UserAccount/UpdateInfo`, vm.identityModel, {headers: {Authorization: "Bearer " + curUser.access_token}})
                            .then(response => isOk = true)
                            .catch(error => {
                                this.$bvToast.toast(error.message, {
                                    title: `Ошибка!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        //если пользователь изменен на идентити
                        if (isOk == true) {
                            this.$store.dispatch('Clients/editMobileUser', vm.editClientModel).then(() => {

                                    vm.$bvToast.toast("Пользователь успешно обновлен", {
                                        variant: "success",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                    vm.hideDetails(true)
                                }
                            ).catch((err) => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        }

                }
                else {
                    this.errors.forEach(err => {
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },

            async deleteItem() {
                const vm = this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            axios.delete(`${vm.$root.identityURL}/api/useraccount/Delete?login=` + this.item.account).then(res => {
                                //после удаления на идентити, удаляем из бд
                                vm.$store.dispatch("Clients/deleteMobileUser", vm.item.id).then(() => {
                                    vm.$bvToast.toast("Пользователь успешно удален", {
                                        variant: "success",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                    vm.hideDetails(true)

                                }).catch(err => {
                                    vm.$bvToast.toast(err.message, {
                                        title: `Ошибка удаления пользователя!`,
                                        variant: "danger",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                });
                            })
                                .catch(error => {
                                    vm.$bvToast.toast(error.response.data ? error.response.data : error, {
                                        title: `Ошибка!`,
                                        variant: "danger",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                });
                        }

                    })
                    .catch(err => {

                    })
            },

            hideDetails(isSave){
                this.$emit('hideDetails', isSave)
            }
        },


    }
</script>

<style lang="scss" scoped>
    .header{
        flex-direction: row;
    }
    .status-label{
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
    }

    @media (max-width:576px){
        .header {
            flex-direction: column;
        }

        .status-label, .subheader-strong-label{
            font-size: 14px !important;
        }
    }
</style>